import React from 'react';

import { Icon } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import { useAppHeaderDimensions } from 'hooks/use-app-header-dimensions';
import useEffectOnce from 'hooks/use-effect-once';

import { BackArrowContainer, SignUpHeader } from './signup-mobile-header.styled';

const SignupMobileHeader = () => {
  const { updateAppHeaderDimensions } = useAppHeaderDimensions();
  const { formatMessage } = useIntl();

  useEffectOnce(() => {
    updateAppHeaderDimensions({
      top: 0,
      left: 0,
      width: 0,
      height: 0,
    });
  });

  return (
    <SignUpHeader>
      <BackArrowContainer onClick={() => window.history.back()}>
        <Icon icon="back" color="icon-default" width="24px" title={formatMessage({ id: 'back' })} />
      </BackArrowContainer>
    </SignUpHeader>
  );
};

export default SignupMobileHeader;
